<template>
  <ims-modal-card :title="$t('about-ims')" @close="$parent.close()">
    <template>
      <img class="logo" src="@/assets/logo.svg">

      <dl>
        <dt>{{ $t('version') }}</dt>
        <dd>{{ version || '?' }}</dd>

        <dt>{{ $t('description') }}</dt>
        <dd>{{ $t('ims-description') }}</dd>
      </dl>
    </template>
  </ims-modal-card>
</template>

<script>
import constants from '@/utils/constants.js';

import ImsModalCard from '@/components/utils/ImsModalCard';

export default {
  name: 'AboutImsModal',
  components: {
    ImsModalCard,
  },
  data() {
    return {
      version: constants.CYTOMINE_COMMERCIAL_VERSION,
    };
  },
};
</script>

<style scoped>
.logo {
  display: block;
  margin: 0 auto;
  max-height: 10rem;
}

.modal-card,
.modal-card-body {
  width: 50vw;
  min-width: 700px;
  font-weight: normal;
}

dt {
  float: left;
  width: 12rem;
  text-align: right;
  padding-right: 1rem;
  clear: both;
  font-weight: 600;
}

dd {
  margin-left: 14rem;
  background-color: #fff;
  margin-bottom: 0.75rem;
}
</style>
